import APPCONFIG from "./Config";

let loadPromise = null;
let loaded = false;
const waiters = [];

export const isGoogleMapsReady = () =>
	loaded || !!(window.google?.maps?.places);

export const getGoogleMapBootstrapURLKeys = () => ({
	key: APPCONFIG.settings.GOOGLE_MAPS_API_KEY(),
	libraries: ["places", "geometry"],
	version: "weekly",
});

export const markGoogleMapsReady = () => {
	loaded = true;
	waiters.splice(0).forEach((resolve) => resolve(true));
	if (!loadPromise) {
		loadPromise = Promise.resolve(true);
	}
};

/**
 * Wait until the shared google-map-react bootstrap has finished loading Maps + Places.
 */
export const loadGoogleMaps = () => {
	if (isGoogleMapsReady()) {
		return Promise.resolve(true);
	}

	if (!loadPromise) {
		loadPromise = new Promise((resolve) => {
			waiters.push(resolve);
		});
	}

	return loadPromise;
};
